module.exports = __webpack_public_path__ + "static/img/2016.95c7985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2016.png
// module id = kF9h
// module chunks = 0